<template>
    <div class="row">
        <div class="col-sm-4">
            <div class="card mx-auto mb-3">
                <span class="card-header">Simple Settings</span>
                <div class="card-body">
                    <form class="form p-3" action="" method="Post" id="simpleSchedulerSettingsForm">
                        <fieldset class="form-group">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyMinute" value="* * * * *">
                                <label class="form-check-label" for="everyMinute">
                                    Every minute
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyFiveMinutes" value="*/5 * * * *">
                                <label class="form-check-label" for="everyFiveMinutes">
                                    Every 5 minutes
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyFifteenMinutes" value="*/15 * * * *">
                                <label class="form-check-label" for="everyFifteenMinutes">
                                    Every 15 minutes
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyThirtyMinutes" value="*/30 * * * *">
                                <label class="form-check-label" for="everyThirtyMinutes">
                                    Every 30 minutes
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyHour" value="0 * * * *">
                                <label class="form-check-label" for="everyHour">
                                    Every hour
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyDay" value="0 0 * * *">
                                <label class="form-check-label" for="everyDay">
                                    Every day<small> at 00:00</small>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyWeek" value="0 0 * * 0" checked>
                                <label class="form-check-label" for="everyWeek">
                                    Weekly<small> Sunday at 00:00</small>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" v-model="simpleSchedulerSettings" name="simpleSchedulerSettings" id="everyMonth" value="0 0 1 * *">
                                <label class="form-check-label" for="everyMonth">
                                    Monthly<small> (First of Month at 00:00)</small>
                                </label>
                            </div>
                        </fieldset>
                        <hr>
                        <button @click.prevent="saveSimpleSchedulerSettings" class="btn btn-success btn-block pull-right" type="submit">Save</button>
                    </form>
                </div>
            </div>
            <div class="card mx-auto mb-3">
                <span class="card-header">Current Settings</span>
                <div class="card-body">
                    <h5 id="current" class="p-2 my-3 border text-center">{{ this.setting.value }}</h5>
                </div>
            </div>
        </div>

        <div class="col-sm-8">
            <div class="card mx-auto mb-3">
                <span class="card-header">Advanced Settings</span>

                <div class="card-body">
                    <form class="form" id="advancedSchedulerSettingsForm">
                        <div class="row align-items-end">
                            <div class="form-group col-sm-6">
                                <label for="hours">
                                    Hours<small> (Hours of Day - Default: 00:MM)</small>
                                </label>
                                <input v-model="hoursOfDay" class="form-control" min="0" max="23" step="1" type="number" id="hours" value="">
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="minutes">
                                    Minutes<small> (Minutes of Hour - Default: HH:00)</small>
                                </label>
                                <input v-model="minutesOfHour" class="form-control" min="0" max="59" step="1" type="number" id="minutes" value="0">
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="dayDate">
                                    Day Date<br><small> (Multiple Selection allowed.)</small>
                                </label>
                                <select v-model="dayOfMonth" multiple class="form-control" id="dayDate">
                                    <option value="*">Default<small class="text-info">(*)</small></option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                    <option value="26">26</option>
                                    <option value="27">27</option>
                                    <option value="28">28</option>
                                </select>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="weekDays">
                                    Days of the Week<br><small> (Multiple Selection allowed.)</small>
                                </label>
                                <select v-model="dayOfWeek" multiple class="form-control" id="weekDays">
                                    <option value="*">Default <small class="text-info">(*)</small></option>
                                    <option value="1">Monday</option>
                                    <option value="2">Tuesday</option>
                                    <option value="3">Wednesday</option>
                                    <option value="4">Thursday</option>
                                    <option value="5">Friday</option>
                                    <option value="6">Saturday</option>
                                    <option value="0">Sunday</option>
                                </select>
                            </div>
                            <div class="form-group col-sm-4">
                                <label for="months">
                                    Months of the Year<br><small> (Multiple Selection allowed.)</small>
                                </label>
                                <select v-model="monthOfYear" multiple class="form-control" id="months">
                                    <option value="*">Default <small class="text-info">(*)</small></option>
                                    <option value=1>January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                            <hr>
                            <div class="form-group col-sm-12 py-3">
                                <div class="text-center">
                                    <em><small class="text-danger text-uppercase">Please be very careful regarding these settings as they can have unexpected results if not properly set up.</small></em>
                                </div>
                            </div>
                            <hr>
                            <div class="form-group col-sm-12">
                                <label for="result">
                                    Result<small> (Crontab Expression Result)</small>
                                </label>
                                <h5 id="result" class="p-2 my-3 border text-center">{{this.crontabResult}}</h5>
                            </div>
                            <div class="col-sm-6">
                                <button id="btnCalculate" @click.prevent="calculateSchedulerSettings" class="btn btn-warning btn-block">Calculate</button>
                            </div>

                            <div class="col-sm-6">
                                <button id="btnSave" v-if="canSave" @click.prevent="saveSchedulerSettings" class="btn btn-success btn-block">Save</button>
                                <h5 v-if="didSave" class="text-primary text-uppercase text-center mt-2">Settings Saved!</h5>
                            </div>
                            <div class="col-sm-12 mt-3 text-center">
                                <small class="text-warning text-uppercase pull-left">Calculate your Arguments before Saving.</small>
                                <small v-if="canSave" class="text-success text-uppercase pull-right">You can now Save your settings.</small>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'scheduler-settings',
        components: {

        },
        props: ['schedulerSetting'],

        data() {
            return {
                simpleSchedulerSettings: "",
                setting: this.schedulerSetting,
                minutesOfHour: 0,
                hoursOfDay: 0,
                dayOfMonth: [],
                dayOfWeek: [],
                monthOfYear: [],
                crontabResult: [],
                arraycrontabResult: [],
                canSave: false,
                didSave: false,
            };
        },
        watch: {
            minutesOfHour(value) {
                this.arraycrontabResult[0] = value;
            },
            hoursOfDay(value) {
                this.arraycrontabResult[1] = value;
            },
            dayOfMonth(value) {
                this.arraycrontabResult[2] = value.join();
            },
            monthOfYear(value) {
                this.arraycrontabResult[3] = value.join();
            },
            dayOfWeek(value) {
                this.arraycrontabResult[4] = value.join();
            },
        },

        mounted() {
            this.arraycrontabResult[0] = 0;
            this.arraycrontabResult[1] = 0;
            this.arraycrontabResult[2] = this.dayOfMonth[0]     = '*';
            this.arraycrontabResult[3] = this.monthOfYear[0]    = '*';
            this.arraycrontabResult[4] = this.dayOfWeek[0]      = '*';
        },

        methods: {

            calculateSchedulerSettings () {
                var minutesOfHourString = this.arraycrontabResult[0].toString();
                var hoursOfDayString    = this.arraycrontabResult[1].toString();
                var dayOfMonthString    = this.arraycrontabResult[2].toString();
                var monthOfYearString   = this.arraycrontabResult[3].toString();
                var dayOfWeekString     = this.arraycrontabResult[4].toString();

                this.crontabResult = minutesOfHourString + (' ') + hoursOfDayString + (' ') + dayOfMonthString  + (' ') + monthOfYearString + (' ') + dayOfWeekString;

                this.canSave = true;
                this.didSave = false;
            },

            saveSchedulerSettings() {
                if (this.canSave) {
                    this.canSave = false;
                    this.didSave = true;
                }

                if (this.didSave) {
                    document.getElementById('btnCalculate').innerText = 'Calculate Again';
                }

                axios.post(this.url("scheduler/update", this.setting.id), {
                    value: this.crontabResult
                })
                    .then(({ data }) => {
                        this.setting.value = this.crontabResult;
                        window.events.$emit("notify", data.notification);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            saveSimpleSchedulerSettings() {
                axios.post(this.url("scheduler/update", this.setting.id), {
                    value: this.simpleSchedulerSettings
                })
                    .then(({ data }) => {
                        this.setting.value = this.simpleSchedulerSettings;
                        window.events.$emit("notify", data.notification);
                    })
                    .catch(( error ) => {
                        console.error(error);
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/Admin/SchedulerSettings.vue